/** Обёртка над Telegram.WebApp. initData доверяем только после проверки на backend (§11.1). */

interface TelegramWebApp {
  initData: string;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  ready: () => void;
  expand: () => void;
  HapticFeedback?: { impactOccurred: (style: string) => void; notificationOccurred: (type: string) => void };
  MainButton: { show: () => void; hide: () => void; setText: (t: string) => void; onClick: (cb: () => void) => void };
  BackButton: { show: () => void; hide: () => void; onClick: (cb: () => void) => void };
  close: () => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: TelegramWebApp };
  }
}

export const webApp = window.Telegram?.WebApp;

export function initTelegram(): void {
  if (!webApp) return;
  webApp.ready();
  webApp.expand();
  applyTheme();
}

function applyTheme(): void {
  const params = webApp?.themeParams ?? {};
  const root = document.documentElement;
  const map: Record<string, string> = {
    bg_color: '--tg-bg',
    text_color: '--tg-text',
    hint_color: '--tg-hint',
    link_color: '--tg-link',
    button_color: '--tg-button',
    button_text_color: '--tg-button-text',
    secondary_bg_color: '--tg-secondary-bg',
  };
  for (const [key, variable] of Object.entries(map)) {
    const value = params[key];
    if (value) root.style.setProperty(variable, value);
  }
  root.dataset.theme = webApp?.colorScheme ?? 'light';
}

export function haptic(type: 'success' | 'warning' | 'error' = 'success'): void {
  webApp?.HapticFeedback?.notificationOccurred(type);
}

/** Вне Telegram отдаём пустую строку — backend ответит 401, и это правильно. */
export function getInitData(): string {
  return webApp?.initData ?? '';
}
